export default "<p>training works!</p>\n"